import { cards } from '@/mocks/home-data';

export default function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          编辑力荐
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={card.cover}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span
                  className={`absolute top-2 left-2 px-2 py-0.5 rounded text-[10px] font-medium ${card.tagBg}`}
                >
                  {card.tag}
                </span>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <div className="flex items-center gap-1 text-background-50">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    <span className="text-xs font-bold">{card.score}</span>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-950 mb-1 line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-2">
                  {card.desc}
                </p>
                <span className="inline-block px-2 py-0.5 rounded bg-accent-100 text-accent-700 text-[10px] font-medium">
                  {card.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}